import { render, staticRenderFns } from "./AllBackups.vue?vue&type=template&id=40e84592&"
import script from "./AllBackups.vue?vue&type=script&lang=ts&"
export * from "./AllBackups.vue?vue&type=script&lang=ts&"
import style0 from "./AllBackups.vue?vue&type=style&index=0&id=40e84592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports